/* eslint-disable id-length */
import React from 'react';
import {setCookie} from '../../../../shared/utilities/cookies';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {Spinner} from '../../../../shared/library';
import Question from '../Question';
import questions from './data/questions';
import styles from '../Question/css/Question.styl';
import _findIndex from 'lodash/findIndex';

class Questionnaire extends React.Component {
  static propTypes = {
    handleClose: React.PropTypes.func.isRequired,
    handleSubmit: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.totalQuestions = questions.length;
    this.questionsAnswered = [];
    this.answerIndexes = [];
    this.state = {progress: 0};
    this.handleAnswer = this.handleAnswer.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSkip = this.handleSkip.bind(this);
  }

  handleAnswer(answer) {
    const answerIndex = parseInt(answer, 10);

    this.answerIndexes[this.state.progress] = answer;

    if (answer === 'Skip' && this.questionsAnswered.length > 0) {
      // // track that the question has been unanswered
      const removeIndex = _findIndex(
        this.questionsAnswered,
        item => item.name === questions[this.state.progress].fieldName
      );

      if (removeIndex > -1) {
        this.questionsAnswered.splice(removeIndex, 1);
      }
    }

    if (!isNaN(answerIndex)) {
      // track the questions answered
      this.questionsAnswered.push({
        name: questions[this.state.progress].fieldName,
        a: questions[this.state.progress].answers[answerIndex],
      });
      // fire off event tracking
      getGATags({
        eventCategory: 'planning_question',
        eventAction: questions[this.state.progress].fieldName,
        eventLabel: questions[this.state.progress].answers[answerIndex],
      });
    }

    if (this.state.progress + 1 >= this.totalQuestions) {
      setCookie(
        '_leg_LG',
        encodeURIComponent(JSON.stringify(this.questionsAnswered)),
        4 / 24
      );
      if (typeof this.props.handleSubmit === 'function') {
        this.props.handleSubmit();
      }
    }
    this.setState({progress: this.state.progress + 1});
  }

  handleBack() {
    // fire off event tracking
    getGATags({
      eventCategory: 'planning_question',
      eventAction: questions[this.state.progress].fieldName,
      eventLabel: 'Back',
    });
    this.setState({progress: this.state.progress - 1});
  }

  handleClose() {
    // fire off event tracking
    getGATags({
      eventCategory: 'planning_question',
      eventAction: questions[this.state.progress].fieldName,
      eventLabel: 'Close',
    });
    this.props.handleClose();
  }

  handleSkip() {
    // fire off event tracking
    getGATags({
      eventCategory: 'planning_question',
      eventAction: questions[this.state.progress].fieldName,
      eventLabel: 'Skip',
    });
    this.handleAnswer('Skip');
  }

  render() {
    const questionNumber = this.state.progress + 1;
    const currentQuestion = questions[this.state.progress];

    if (this.state.progress >= this.totalQuestions) {
      return (
        <div className={styles.Question}>
          <p className={styles.QuestionText}>
            Generating your personalized recommendations...
          </p>
          <div style={{padding: '32px 0 40px 0'}}>
            <Spinner />
          </div>
        </div>
      );
    }

    return (
      <Question
        answerIndex={this.answerIndexes[this.state.progress]}
        answers={currentQuestion.answers}
        handleAnswer={this.handleAnswer}
        handleBack={this.handleBack}
        handleClose={this.handleClose}
        handleSkip={this.handleSkip}
        help={currentQuestion.help}
        question={currentQuestion.question}
        step={questionNumber}
        total={this.totalQuestions}
      />
    );
  }
}

export default Questionnaire;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/Questionnaire/index.js